import { toast } from "react-toastify";

const defaultOptions = {
  position: toast.POSITION.TOP_CENTER,
  autoClose: 3000,
  hideProgressBar: true,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
};

const Toast = {
  info: (textOrComponent: any, options = {}) => {
    toast.info(textOrComponent, {
      // To prevent toasts with duplicate text. For components, provide a custom id:
      toastId: textOrComponent,
      ...defaultOptions,
      ...options,
    });
  },
  error: (textOrComponent: any, options = {}) => {
    toast.error(textOrComponent, {
      // To prevent toasts with duplicate text. For components, provide a custom id:
      toastId: textOrComponent,
      ...defaultOptions,
      autoClose: false,
      ...options,
    });
  },
  update: (id: string, options = {}) => {
    toast.update(id, options);
  },
  dismiss: (id: string) => {
    toast.dismiss(id);
  },
  dismissAll: () => {
    toast.dismiss();
  },
};
export const notifyToastMessage = (message: string, autoClose = 5000) => {
  if (message) {
    Toast.info(message, {
      onClose: () => {},
      autoClose,
    });
  }
};

export const notifyToastError = (message: string, autoClose = 5000) => {
  if (message) {
    Toast.error(message, {
      onClose: () => {},
      autoClose,
    });
  }
};
export const updateToastMessage = (id: string, options = {}) => {
  Toast.update(id, options);
};

export const dismissToast = (id: string) => {
  Toast.dismiss(id);
};

export const dismissAllToasts = () => {
  Toast.dismiss("");
};

export const notifyToastAction = (Component: any, options: any) => {
  Toast.info(Component, {
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    closeButton: false,
    draggable: false,
    ...options,
  });
};
